export default __webpack_public_path__ + "static/media/logo_700x700_transparent_white.15cd532c.svg";